import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { TInterviewAssessment, TInterviewAssessmentVariables } from './saveInterviewAssessment';

import { notifyMeta } from '@/lib/notify';
import { INTERVIEW_KEYS, SCORE_KEYS } from '@/constants/queryKeys';

import { saveInterviewAssessment } from './saveInterviewAssessment';

const useInterviewAssessment = () => {
  const queryClient = useQueryClient();

  return useMutation<TInterviewAssessment, Error, TInterviewAssessmentVariables>({
    meta: notifyMeta('assessmentSave'),
    mutationKey: ['interviews', 'assess'],
    mutationFn: saveInterviewAssessment,
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: INTERVIEW_KEYS.root }),
        queryClient.invalidateQueries({ queryKey: SCORE_KEYS.root }),
      ]);
    },
  });
};

export {
  useInterviewAssessment,
};
